/**
 * Resolves a property path (as carried by a Zod issue's `path`) against the value that was parsed.
 *
 * Returns `undefined` as soon as the path leaves the object graph, which makes "this key was never
 * provided" and "this key was provided as undefined" indistinguishable — that is intentional, since
 * both are the absent case for the callers here.
 */
export function valueAtPath(root: unknown, path: ReadonlyArray<PropertyKey>): unknown {
  let current = root;

  for (const key of path) {
    if (current === null || (typeof current !== "object" && typeof current !== "function")) {
      return undefined;
    }

    current = (current as Record<PropertyKey, unknown>)[key];
  }

  return current;
}
